(() => {
  const root = document.querySelector("[data-gigi-careers]");

  if (!root) return;

  const roleInput = root.querySelector("[data-career-role-input]");
  const interestSection = root.querySelector("#career-interest");

  root.querySelectorAll("[data-career-role]").forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      if (!roleInput || !interestSection) return;

      const role = trigger.getAttribute("data-career-role");
      if (!role) return;

      event.preventDefault();
      roleInput.value = role;
      roleInput.dispatchEvent(new Event("input", { bubbles: true }));
      interestSection.scrollIntoView({ behavior: "smooth", block: "start" });
      window.setTimeout(() => roleInput.focus({ preventScroll: true }), 450);
    });
  });

})();
